module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow_em_hover-499f9e22f50cc086344a8090dcead076.svg";